/** `/c/$companyId/reports/ledger?scope&account&from&to` — Back keeps the filters. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { LEDGER_SCOPES, LedgerScreen } from "../reports/LedgerScreen";

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
const search = z.object({
  scope: z.enum(LEDGER_SCOPES).catch("ALL"),
  account: z.string().uuid().optional().catch(undefined),
  from: isoDate.optional().catch(undefined),
  to: isoDate.optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/c/$companyId/reports/ledger")({
  validateSearch: (raw) => search.parse(raw),
  component: Ledger,
});

function Ledger(): JSX.Element {
  const { companyId } = Route.useParams();
  const current = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <LedgerScreen
      companyId={companyId}
      search={current}
      onSearch={(next) => void navigate({ search: next })}
    />
  );
}
